export const periodOptions = [
  { label: "Daily", value: "daily" },
  { label: "Monthly (30 days)", value: "monthly" },
  { label: "90 days", value: "90days" },
];

export const formatUsd = (value) => {
  const n = Number(value || 0);
  if (!Number.isFinite(n)) return "—";
  if (Math.abs(n) < 0.01) return `$${n.toFixed(4)}`;
  return `$${n.toFixed(2)}`;
};

export const formatPct = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return `${n.toFixed(1)}%`;
};

